import React, { useMemo } from 'react';
import { TextInformationWrapper } from './TalkiMessage';
import styled from 'styled-components';
import DoubleArrowIcon from '@/common/images/daily/double-arrow.svg';
import InfoIcon from '@/common/images/daily/information-blank.svg';

const Circle = styled.div`
	width: 12px;
	height: 12px;
	aspect-ratio: 1;
	border-radius: 50%;
	background-color: ${(props) => (props.isOkay ? '#32951B' : '#F5BC2F')};
	margin-top: 2px;
`;

export const TextInfomation = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px;
	gap: 10px;
	background: #eef2f5;
	border-radius: 8px 8px 0px 8px;
	padding: 14px;
	font-family: Lato;
	font-size: 14px;
	font-weight: 400;
	text-align: left;
	max-width: 600px;
	color: #29185e;
	line-height: 123.5%; /* 14.82px */
	letter-spacing: 0.24px;
	margin-right: 10px;

	@media (max-width: 600px) {
		max-width: 300px;
	}
`;

const Spacer = styled.div`
	height: 1px;
	width: 100%;
	background-color: #cfcfcf;
`;

const HintWrapper = styled.div`
	display: flex;
	color: #7f7c85;
	width: 100%;
	gap: 10px;
	padding-left: 20px;
	box-sizing: border-box;
`;

const BottomWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const IconButton = styled.img`
	padding: 3px;
	cursor: pointer;
	width: 16px;
`;

const TopWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: 10px;
`;

const UserMessageWithActiveHelp = ({
	message,
	userMessageId,
	messageScore,
	isExpanded,
	toggleAreHintsExpanded,
	onReportFeedback,
}) => {
	const score = useMemo(
		() => messageScore?.find((f) => f.userMessageId === userMessageId),
		[messageScore],
	);

	return (
		<TextInformationWrapper>
			<TextInfomation>
				<TopWrapper>
					{score && score.score !== 'ok' && <Circle isOkay={false} />}
					<div>{message}</div>
				</TopWrapper>
				{score && score.score !== 'ok' && (
					<>
						<Spacer />
						{isExpanded && (
							<HintWrapper>
								<div>{score.explanation}</div>
							</HintWrapper>
						)}
						<BottomWrapper>
							<IconButton
								style={{
									transform: !isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
								}}
								src={DoubleArrowIcon}
								alt='expand'
								onClick={toggleAreHintsExpanded}
							/>
							{isExpanded && (
								<IconButton
									src={InfoIcon}
									alt='report'
									onClick={() =>
										onReportFeedback(`FEEDBACK: ${score.explanation}`)
									}
								/>
							)}
						</BottomWrapper>
					</>
				)}
			</TextInfomation>
		</TextInformationWrapper>
	);
};

export default UserMessageWithActiveHelp;
